<section
  class="px-4 py-14 bg-ayr-white dark:bg-ayr-black text-ayr-grey-700 dark:text-ayr-white"
>
  <div class="max-w-[620px] grid justify-center m-auto">
    <h2
      class="text-27 lg:text-47 ayr-underline dark:text-shadow text-center inline m-auto font-bold "
    >
      #choosezero
    </h2>
    <ng-container *ngTemplateOutlet="chooseZero"></ng-container>
  </div>
</section>
